import { Lightning } from "@phosphor-icons/react";

export default Lightning
